import { useMemo } from 'react';
import { Case } from '@/api/apis/case';
import { LegLocationTypeEnum, RouteLocationType, TxCenterRouteLocation } from '@/api/apis/route';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';

export const useRouteMainLocations = () => {
  const data = useBaseCaseDetails() as Case;

  return useMemo<RouteLocationType[]>(
    () =>
      [
        ...(data.donorHospitalDetails
          ? [
              {
                id: data.donorHospitalDetails.id,
                locationType: LegLocationTypeEnum.hospital,
                name: data.donorHospitalDetails.name,
                code: data.donorHospitalDetails.code,
                logoPath: data.donorHospitalDetails.logoPath,
                location: data.donorHospitalDetails.location,
              },
            ]
          : []),
        ...(data.txCenterDetails
          ? [
              {
                id: data.txCenterDetails.id,
                locationType: LegLocationTypeEnum.txcenter,
                name: data.txCenterDetails.name,
                code: data.txCenterDetails.code,
                logoPath: data.txCenterDetails.logoPath,
                location: data.txCenterDetails.location,
              } as TxCenterRouteLocation,
            ]
          : []),
      ] as RouteLocationType[],
    [data.donorHospitalDetails, data.txCenterDetails],
  );
};
